import { Input, Button, Col, Row } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage, useIntl } from "react-intl";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";
import TooltipHelp from "../Help/ToolTipHelp";

export default function DeleteUser() {
  const intl = useIntl();
  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="DeleteRestoreUser" />
            <TooltipHelp
              id="FinalExam"
              toolTipText={
                <FormattedMessage id="DeletedTeacherCannotBeRestoredHere" />
              }
              placement="right"
            />
          </h5>
        </Col>
      </Row>

      <Row>
        <Col xs="3" className="mb-2">
          <p>
            <Input id="user-delete-email" placeholder="email" />
          </p>
          <div>
            <p>
              <input
                type="radio"
                id="radioDeleteUser"
                name="deleteRestoreUser"
                defaultChecked
              />{" "}
              <FormattedMessage id="Delete" />
            </p>
            <input
              type="radio"
              id="radioRestoreUser"
              name="deleteRestoreUser"
            />{" "}
            <FormattedMessage id="Restore" />
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Button
            color="primary"
            outline
            onClick={() => {
              var isDeleteOperation =
                document.getElementById("radioDeleteUser").checked;
              var userEmail = document
                .getElementById("user-delete-email")
                .value.trim();

              axios
                .post(
                  `${API_BASE_URL}/User/SetDeleted?email=${encodeURIComponent(
                    userEmail
                  )}&isDeleted=${isDeleteOperation}`
                )
                .then((response) => {
                  if (!response?.data?.result?.name) {
                    toast.warn(
                      intl.formatMessage({ id: "ServerResponseInvalid" })
                    );
                    return;
                  }

                  var userName = response.data.result.name;
                  var isDeleted = response.data.result.isDeleted
                    ? intl.formatMessage({ id: "Yes" })
                    : intl.formatMessage({ id: "No" });

                  toast.success(
                    intl.formatMessage(
                      { id: "UserNowHasDeletedStatus" },
                      { userName, status: isDeleted }
                    )
                  );
                })
                .catch((err) => {
                  toast.warn(formatServiceError(intl, err?.response?.data));
                });
            }}
          >
            <FormattedMessage id="DeleteRestore" />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
